import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, Linkedin } from "lucide-react";
import Logo from "./Logo";
import { COMPANY } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#1c1c1e] text-white mt-0">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="[&_span]:!text-white mb-5">
              <Logo light />
            </div>
            <p className="text-white/60 text-[14px] leading-relaxed max-w-xs">
              Bath &amp; Bristol's trusted local property experts. Honest advice,
              seamless service, and results that move you forward.
            </p>
            <div className="flex gap-3 mt-6">
              <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#b8935f] hover:border-[#b8935f] transition-colors">
                <Instagram size={16} />
              </a>
              <a href={COMPANY.linkedin} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#b8935f] hover:border-[#b8935f] transition-colors">
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-[13px] tracking-[0.2em] text-[#b8935f] mb-5">CONTACT US</h4>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-white/70 text-[14px] hover:text-white transition-colors">
                  <Mail size={15} className="text-[#b8935f]" />
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={COMPANY.phoneHref} className="flex items-center gap-3 text-white/70 text-[14px] hover:text-white transition-colors">
                  <Phone size={15} className="text-[#b8935f]" />
                  {COMPANY.phone}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-[13px] tracking-[0.2em] text-[#b8935f] mb-5">USEFUL LINKS</h4>
            <ul className="space-y-3">
              <li><Link to="/about-us" className="text-white/70 text-[14px] hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-white/70 text-[14px] hover:text-white transition-colors">Our Services</Link></li>
              <li><Link to="/buying" className="text-white/70 text-[14px] hover:text-white transition-colors">Buying</Link></li>
              <li><Link to="/lettings" className="text-white/70 text-[14px] hover:text-white transition-colors">Lettings</Link></li>
              <li><Link to="/blog" className="text-white/70 text-[14px] hover:text-white transition-colors">Weekly Blog</Link></li>
              <li><Link to="/calculators" className="text-white/70 text-[14px] hover:text-white transition-colors">Calculators</Link></li>
              <li><Link to="/favourites" className="text-white/70 text-[14px] hover:text-white transition-colors">Saved Homes</Link></li>
              <li><Link to="/privacy-policy" className="text-white/70 text-[14px] hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" className="text-white/70 text-[14px] hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/cookie-policy" className="text-white/70 text-[14px] hover:text-white transition-colors">Cookie Policy</Link></li>
              <li><Link to="/complaints-procedure" className="text-white/70 text-[14px] hover:text-white transition-colors">Complaints Procedure</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-5 text-white/40 text-[12px] leading-relaxed" data-testid="footer-regulatory">
          {COMPANY.legalName} · Registered in England &amp; Wales · Company No. {COMPANY.companyNumber}{COMPANY.vatNumber && COMPANY.vatNumber !== "Not VAT registered" ? ` · VAT ${COMPANY.vatNumber}` : ""}.
          {" "}Registered office: {COMPANY.registeredAddress}. Registered with the ICO ({COMPANY.icoNumber}).
          {" "}Member of {COMPANY.redressScheme}. Client money protected by {COMPANY.cmpScheme}.
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-[13px]">Copyright Anadear Estates Ltd 2026</p>
          <p className="text-white/40 text-[13px]">All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
